import { createApi } from '@reduxjs/toolkit/query/react'
import customBaseQuery from '@lxp-app/utils/customBaseQuery'

// ⚠️ --- This is the placeholder for your import --- ⚠️
//
// Please update the path './baseQuery' to point to the file
// where your existing baseQuery is defined.
//import { baseQuery } from './baseQuery'

/**
 * Creates the RTK Query API slice.
 * This file defines all the endpoints for your application.
 * It uses the 'baseQuery' you are importing.
 */
export const aiInterviewApiSlice = createApi({
  // The reducerPath is where this slice will live in your Redux state
  reducerPath: "AiInterview",

  // Here, we are using your imported 'baseQuery'.
  // This 'baseQuery' should already handle the base URL
  // and any authentication (like setting the Bearer token).
  baseQuery: customBaseQuery,

  // 'endpoints' replaces your individual async functions.
  // 'builder.query' is for GET requests (fetching data).
  // 'builder.mutation' is for POST, PUT, DELETE, etc. (changing data).
  endpoints: (builder) => ({
    // Health check - FIXED: Must return object with url property
    healthCheck: builder.query({
      query: () => ({
        url: "/health",
        method: "GET",
        headers: {
          'service': 'interview'
        }
      }),
      extraOptions: { service: "AI_Interview" }
    }),

    // Restore session
    restoreSession: builder.query({
      query: (sessionId) => ({url :`/session/${sessionId}/restore` ,method : "GET", headers: {
         'service': 'interview'
      }}),
      extraOptions:{service:"AI_Interview"}
    }),

    // Download transcript
    // This endpoint will fetch the data as a blob.
    // The download logic (creating a link) will now live
    // in the component that calls this hook.
    downloadTranscript: builder.query({
      query: (sessionId) => ({
        url: `/download_transcript/${sessionId}`,
        method  : 'GET',
        headers: {
         'service': 'interview'
      },
        // Tell RTK Query to expect a blob response
        // Your custom baseQuery should respect this.
        //responseHandler: (response) => response.blob(),
        responseHandler: "text",
        // We can set cache to 'no-cache' to ensure it always re-fetches
      }),
      extraOptions:{service:"AI_Interview"}
    }),

    // Start interview
    startInterview: builder.mutation({
      query: ({ userId, jdFile, resumeFile }) => {
        // Create the FormData object
        const formData = new FormData();
        formData.append("user_id", userId);
        formData.append("created_at", new Date().toISOString());
        formData.append("updated_at", new Date().toISOString());
        formData.append("jd_file", jdFile);
        formData.append("resume_file", resumeFile);

        // Return the request details
        return {
          url: "/form/start_interview",
          method: "POST",
          headers: {
         'service': 'interview'
      },
          body: formData
          // Your baseQuery must be configured to handle FormData
          // bodies correctly (i.e., by letting the browser
          // set the 'Content-Type' header).
        };
      },
      extraOptions:{service:"AI_Interview"}
    }),

    // End other sessions
    endOtherSessions: builder.mutation({
      query: ({ userId }) => ({
        url: "/end_other_sessions",
        method: "POST",
        headers: {
         'service': 'interview'
      },
        body: { user_id: userId }
      }),extraOptions:{service:"AI_Interview"}
    }),

    // Replay audio
    replayAudio: builder.mutation({
      query: ({ text }) => ({
        url: "/replay_audio",
        method: "POST",
        headers: {
         'service': 'interview'
      },
        body: { text }
      }),extraOptions:{service:"AI_Interview"}
    }),

    // Transcribe audio
    transcribeAudio: builder.mutation({
      query: (audioBlob) => {
        const formData = new FormData();
        formData.append("audio", audioBlob, "audio.webm");

        return {
          url: "/form/transcribe_audio",
          method: "POST",
          headers: {
         'service': 'interview'
      },
          body: formData
        };
      },extraOptions:{service:"AI_Interview"}
    }),

    // Evaluate interview
    evaluateInterview: builder.mutation({
      query: ({ sessionId }) => ({
        url: "/evaluate",
        method: "POST",
        headers: {
         'service': 'interview'
      },
        body: { session_id: sessionId }
      }),extraOptions:{service:"AI_Interview"}
    }),
        manualEvaluate: builder.mutation({
      query: (formData) => ({
        url: '/form/manual_evaluate',
        method: 'POST',
        headers: {
         'service': 'interview'
      },
        body: formData
      }),extraOptions:{service:"AI_Interview"}
    }),
        downloadEvaluationPdf: builder.query({
      query: (sessionId) => ({
        url: `/download_evaluation_pdf/${sessionId}`,
        method : 'GET',
        headers: {
         'service': 'interview'
      },
        responseHandler: (response) => response.blob()
      }),
      extraOptions:{service:"AI_Interview"}
    }),
      getEvaluation: builder.query({
      query: (sessionId) => ({url: `/evaluation/${sessionId}`,
      method:'GET',
    headers: {
         'service': 'interview'
      }}),
      extraOptions:{service:"AI_Interview"}
    }
    ),
        evaluateSession: builder.mutation({
      query: (sessionId) => ({
        url: '/evaluate',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',

         'service': 'interview'
        },
        body: JSON.stringify({
          session_id: sessionId
        })
      }),
      extraOptions:{service:"AI_Interview"}
    })
  })
});

// RTK Query automatically generates React hooks for each endpoint.
// We export these hooks to be used in our components.
export const {
  // Query hooks
  useHealthCheckQuery,
  useLazyHealthCheckQuery, // 'Lazy' version for non-automatic fetching
  useRestoreSessionQuery,
  useLazyRestoreSessionQuery,
  useLazyDownloadTranscriptQuery, // Use lazy query for on-demand downloads

  // Mutation hooks
  useStartInterviewMutation,
  useEndOtherSessionsMutation,
  useReplayAudioMutation,
  useTranscribeAudioMutation,
  useEvaluateInterviewMutation,
  useEvaluateSessionMutation,
  useLazyGetEvaluationQuery,
  useLazyDownloadEvaluationPdfQuery,
  useManualEvaluateMutation
} = aiInterviewApiSlice;
